import React from 'react'

type ActiveTab = 'dashboard' | 'performance' | 'reports'

interface ClientDashboardV3LayoutProps {
  activeTab: ActiveTab
  children: React.ReactNode
}

export default function ClientDashboardV3Layout({ activeTab, children }: ClientDashboardV3LayoutProps) {
  return (
    <section
      data-v3-active-tab={activeTab}
      className="dashboard-v3 mx-auto w-[95%] py-6"
    >

      {children}
    </section>
  )
}

